common.View.create('event::canvas.blocks.modules.events.Block', {

    onDOMLoad()
    {
        this.initSlider();
    },

    initSlider()
    {
        this.element.find('.owl-carousel').owlCarousel({
            loop: false,
            margin: 50,
            items: 1,
            nav: true,
            dots: false,
            autoplay: false,
            autoplayTimeout: 4444,
            autoplayHoverPause:true,
            stageClass: 'owl-stage flex cursor-grab',
            responsive: {
                0: {
                    items: 1
                },
                640: {
                    items: 2
                },
                1024: {
                    items: 4
                }
            }
        });

    }
});
